import React, { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { applyKey, formatCurrency } from "../../../../utils";
import {
  MapaImage,
  MapaPremiosContainer,
  MapaPremiosContent,
  Regiao,
  RegionDetails,
} from "./MapaPremios.Style";
import { JsonData, Text } from "../../../../components";

const REGIOES_BRASILEIRAS = {
  NORTE: `M97,180.6c2.4-0.1,3-4.2,3.4,1.9c0.2,2.8-1.8,5.2-0.9,7.8c0.9,1.4,1.3,3,1.2,4.6
  c-2,2.1,1.6,10.8,3.4,11.2c1.8-1.5,6,5.2,7.9,5.3c5.5,1.2,10.4-0.1,14.5,3.8c2.2,2.1,4.6,3.2,7.7,3.9c2.8,0.7,3.5,4,5.9,4.7
  c2.7,0.7,6.5-1.2,9.1-0.3c4.6,1.6,2.1,1,6.6-0.1c1.8-1.9,22-20.7,18.2-34c-3.3-11.6-30.8-18-30-19.3c0-0.6,0-1.1-0.1-1.5
  c9.1,0.7,29.3,5.2,40.4,7.3c0.1,0.9,0.2,1.7,0.3,2.3c0.3,1.1,53.5,4.3,76.8,3.8c-2.7,26.4,1.6,52.6,28.4,53.5
  c16.1,0.6,45-31.6,44.8-45.3c-0.1-13.6-17.2-58.4-22.3-66.1c-2.1-3.1-8.8-3.3-16-2.4c1.2-0.9,2.4-1.7,3.4-2.7
  c2.8,0.5,3.1-3.4,5-4.3c-0.1-1.9,3.8-7.2,4.7-9.2c0.8-1.8,2.6-5.1,3.7-6.8c1.5-2.3,8.4-17.7,6.4-21.5c-0.4-0.7-5.3-1.3-5.2-1.2
  c-3.8-1.2-7.2-3.1-11.9-3.6c-1-0.1-13.4,0.5-9.2-3.9c-2.8-2-7.4-1-10.6-3c-1.7-1.1-2.5-4.3-4.6-4.7c-4,2-4.4-4.3-6.4-3.9
  c0.6-1.6,1.1-2.8,1.7-3.3c3.3-3.1,3.3-7.7-0.1-9.3c-1.4-0.7-8.1-8.6-7.9-8.7c-1.5-6.7-1.5-18.2-7.6-22.5
  c-3.9,3.4-4.9,11.1-9.4,14.7c-0.2,3.6-3.3,10.8-7.3,11.6c-3.4,0.7-5.4-2.7-9-2.1c-2.6,0.4-3.3,2.9-6.6,1.7
  c-1.8-0.6-3.3-2.5-5.7-2.6c-0.7-1.2-1.9-1.8-3.8-1.1c-2.7,0.9-7.1-0.5-8.8,0.1c-4,1.3,0.9,5.2,0.3,7c-1.1,3.2-12.9-2.1-14.7-0.4
  c-1.3-0.3-2.2,0.1-2.7,1.4c-0.4,1.9-1.6,2.4-3.5,1.6c-3.5,0.6-1.8,2.7-5,1.8c-2.3-0.7-5.6,6.5-7.9,3.8c0,0.4-0.1,0.9-0.2,1.5
  c0-0.4-0.1-0.7-0.1-1.1c-0.1-2.1-4-2.3-5.7-4.4c-2.9-3.5-5.1-7.3-6.1-12.2c-0.5-2.3,0.2-10,1.4-11.5c0.9-1.2,3-2.3,3.4-4
  c1.4-5.3-7.7-5.4-5.7-9.4c2.5-4.9-5.1-8.6-7.3-5.7c-1.5,1.9,1.9,4.3-2.6,6.4c-0.1,2.4-3.3,2-4.6,1.5c1.6,2.1-8.3,4-9,5.1
  c-1.2,0.1-4-1.8-4.8-0.1c0,1-0.5,1.3-1.5,0.8c-2.4,0.1-0.3,2.9-0.7,3.8c-1.1,2.3-6.3-3.2-8.2-1.9c-1.2,0.2-2-0.4-2.4-1.7
  c0.4,3.2-12.7-3-12.8-2.8c-0.9,3.1,6,6.2,7,9c-1.7,1.6,2.1,12.3,3.3,12.5c1.2,0.2,2.5,1.6,3.8,3.8c-0.9,0.5-1.8,1.1-2.8,1.4
  c-4.3-1.3-3,8.1-6.5,7.1c-1.6-0.5-0.5-1-3.5,1.2c-1.1,0.8-3.9,1.1-4.8,1.6c-1,0.6-3.2,6-4.8,5.6c-1.7-0.4,1.9-4.8-2.4-3.8
  c-3.1,0.7-3.2,3.8-7,2.1c-3.1-1.4-4.3-4.7-7.3-4.2c-1.3,0.2-1.2-1.5-1.2-2.2c0.1-1.6-2-11.3-4.5-9.8c-1.4,0.8-3.3,2.4-4.6,3.8
  c-1.6,1.7-1.9-1.2-3.2-1c-1.1,0.1-1.5,2.8,0,2.6c-3.2,0.4-18-1.9-19.1,1.4c-1.2,3.9-0.7,5.9,2.7,6.4c5.8,0.8,3,1.1,5.5,5.1
  c-3.2,0.8-6.2-0.9-9.7,0.9c-1.7,0.9-1.4,6.7-1.1,8.1c0.5,2.4,3.3,2.9,4.8,4.5c0.8,0.9,2.5,5.8,2.8,7.2c-1.2,9.8-3.1,19.4-4.9,29.1
  c-0.6,3.3-1.9,12.8-5.6,7c-1.8-2.8-9.8,2.8-12,3c-5.4,0.4-8.7,3.1-13.1,6.1c-4,2.7-7.1,8.1-8.2,13.1c2.4,8.4-6,9.4-6.4,12.1
  c0,0,0,0,0,0c2.9,3.4-2,1.6-1.9,4.8c0,1.3,3.1,5,3.6,6c2.1,3.8,11.5,12.3,5.2,15.7c3.3,0.4,9.3,0.2,10.6,3.8c0.5,1.5,0.9,4,3.1,4
  c8.4,0.2,9.9-3.9,16.7-7c0.8,0.9-1.1,6-1.2,7.5c-0.2,3.6,0.5,7.3,0.2,10.9c0.7-0.7,10.7-0.5,12.6-0.6c3.8-0.3,8,2.3,11,1.7
  c3.2-0.6,4.3-5.3,7.2-5.3c3.3,0.1,1.7,0.5,4.6-2c2.4-2,7.1-5.2,10-6.4 M181.2,150c0.2,0.1,0.3,0.3,0.3,0.4c1.2,1,1.8,3.2,2.1,5.9
  C182.9,153.9,182.1,151.8,181.2,150z`,
  "CENTRO-OESTE": `M317.3,227.5c-0.5-2.2,0.5-5.1,2.4-6.5c-3.8,0.6-3.9-1.5-1.3-3.8c-1.6,1.4-2.1-0.4-2.9-1.3
  c0.2,0.9-6.6,3.3-7.7,3.7c-2.4,0.9-5.3-0.8-6.4-0.4c-0.8,0.3,0,2.4-0.2,3.2c0-1.4-8.7-1.6-8.9-1.4c-0.3-0.4-0.5-0.9-0.6-1.4
  c-0.6,0-1,0.4-1,1.1c-0.4-1.1-3.1-5-3.5-5.3c-1.6,3.8-2.9-2-4.5,1.5c-0.5,1.2-0.4,4.8-2.7,3.1c-3.5-4.5-12.1-1.8-7.2-9.4
  c-2.5,1.2-4,3.6-4.9,6.3c0-1.2,0.1-2.3-1.4-3.3c1.9-2.9-0.4-7.1,0.1-10.1c1.1-7.6,1.6-14.8,5.1-22.6c-20.1-2.1-40.3-3.1-60.5-4.8
  c-6.3-0.5-14,0.5-17.1-4.7c-1.3-2.1-4.5-2.3-5.9-4.3c-1.5-2.2-0.8-5.2-1.9-7.7c-0.3-0.6-3.3-8.9-4.4-7.8c-1.3,1.3-0.6,4.2-2.6,5.1
  c1.4,3.3-1.6,7.3-0.4,9.7c1.5,3.1-5.8,1.8-7.4,1.8c-8,0.1-16.4,0.6-24.3-0.2c-6.9-0.7-1,5.4-5,5.7c-0.3,0.8,1.3,2.7,1.5,3.3
  c0.5,2.3-0.8,5.2-0.8,7.5c0,3.2,1,5.7,0.5,9.2c1.8,0.7,4.1,0.2,5.9,0.1c2.6-0.2,12.1,0.1,12.3,3.8c0.1,3.3-4.3,4.4-0.4,8
  c-0.3,1.9,2.7,3.6,1.5,5.6c-3.2,0.2-4.8,9.1-6.5,11.6c-0.8,1.2-5,2.2-2.1,3.6c1.1,0.5,1.8,1,2.1,2.4c0.4,2.1-0.5,3.8,0.7,6.4
  c1.8,3.9-0.4,3.8-0.9,6.8c-0.8,4.5,3.7,8.8,2.9,13.8c7-0.1,14.1,0.9,21.1,0.3c-0.1,3.9-3,6.2-0.7,10.2c2.2,3.8,6.9,2.7,8.3,6.3
  c-0.8-0.9-1.4-1.7-1.4-1.7c-1.6,2.2,4.1,6.5,2.4,9.8c-2.1,4.2-3.2,9.1-5.3,13.6c-0.9,4.9,3.1,3.2-0.9,6.8c-1,0.9,2.4,7.8,2.5,8.1
  c1,1.9,0.5,9-0.5,11.9c1,0.5-2.5,4.2,1.6,3.5c2.6-0.4,5.3,1.2,8.2,1.2c2.4,0.4,4.4,0.7,6.1-1.1c0.4-0.4,6.3,1.3,7.5,1.9
  c4.7,2.5,2.8,12.7,4.8,17.1c-0.8,3.6,3.1,2.7,5.2,2.4c4.5-2.3,4.2,0.4,8.1,0.9c2.1,0.2,41.6-5.3,41.6-5.3s0.7-31.7,0.9-49.7
  c11.1-3.7,44.9-11.3,46.5-10.4c0.5,0.2,0.8,0.3,0.9,0.2c1.5-1.2-14-18.8-11.3-25.6c1.2-3.2,3.2-4.1,3.2-4.1c1.3-0.6,2.1-0.2,2.6-1
  c0.8-1.3-0.9-3.7-0.2-5.8c0.6-1.7-2.2-3.6,1.1-3.9c1.7,1.1,2.6,0.9,2.8-0.6c0.3-6.2,1.1,0,4.3-0.7c2.9-0.6,0.5-5.8,2.3-6.1
  C321.1,233.5,317.7,229.1,317.3,227.5z`,
  SUL: `M287.2,370.7c0.6-0.3,1.1-0.5,1.5-0.5c2.7-0.1,6.7-6.8,8.4-9c-2.1,0.8-13.3-33.6-17.9-33.8
  c-7.5-0.3-42.1-0.7-46.5,9.2c-1.2,2.7-3.4,2.9-4,5.6c-0.4,1.9-0.4,4.5-2.7,5.2c-0.9,0.9-1.1,7.3-1.4,8.7c-0.5,2.6-0.6,5.3-2.4,7.5
  c0.3,4.1,4.4,0.9,5.9,1.7c3.4,1.7,2.2,6.8,6.1,8.2c0.1,0,0.2,0,0.3,0c-3.4,1.1-1.9,7.3-3.5,10.4c0.1,0,0.3,0,0.6,0
  c-1.5,0.2-2.9,0.6-3.3,1.3c-0.7-0.4-6,3.1-7.4,3.3c-0.1,0-6.8,4.3-7.1,4.8c-1.1,3.2-5.2,0.9-3.9,4.8c-0.6-1.8-8.8,8-9.2,8.3
  c-2.1,1.9-9,7.7-9.5,10.4c-0.9,1.2-2.1,2-3.5,2.4c3.4,4.3,5.6-2.2,9.1-0.8c2.9,1.2,5.4,4.7,7.7,6.7c1.7,1.5,1,5.5,3.6,4.3
  c1.8-0.9,2.3-3,4.2-1.2c3.1,3,29.4,19.5,25.6,22.7c-6.1,5.2-4,13.7,4.1,5.8c5.9-5.8,5.9-12.8,13.3-17.7c7-4.7,12.2-9.8,15.9-17.4
  c1.7-3.5,3.2-7,5.3-10.2c2.4-2.3,6.7-8.4,9.5-9.9c6.8-3.7,1.6-10.9,5.1-15.3c0.2,0.1-1.8-9.3-0.5-10.7
  C294,370.9,291.1,370.3,287.2,370.7z`,
  NORDESTE: `M417.5,200.1c5-2.8,5.1-11.2,11.9-11.6c0-0.3-0.2-0.6-0.3-0.8c1.2-0.2,2.1-2.8,4-4.1
  c2.9-4.2,8.2-7.9,10-12.8c0.2-0.4,0.1-0.8-0.1-1c0.7-0.9,1.3-1.7,1.6-2.4c1.1-2.7,1.6-5.6,2.7-8.3c-0.5-1.9-0.3-4.6-1.3-6.1
  c0.2,0.2,0.5,0.4,0.7,0.7c2.4-0.2,0-11.6-1.4-12.2c0,0-0.1,0-0.1,0c0.3-0.1,0.5-0.1,0.6-0.2c-2.4-5.5-1.7-15.3-9.2-16.5
  c-5.2-0.8-9.5-0.5-14.6-1.7c-1.7-0.4-3.1-0.6-4.2-0.4c1-0.8,1.8-1.3,1.8-1.2c-0.3-1.9-6.6-4.9-7.9-6.2c-3.7-3.6-6.5-6.1-10.6-9.1
  c-10.1-7.6-15.6-8.1-27.7-6.7c0.3,0.2,0.4,0.4,0.5,0.6c-0.5-0.4-4.7-1.8-6-2.1c0.1-0.7-0.2-1.1-1.3-0.9c-1.9,0.4-6.1,0.3-8.2-0.2
  c-6.8-1.5-10.2-8.1-15.3-1.5c0.6-1.2-2-1.5-0.8-1.9c-7.8,2.6-3.5-10.1-9.1-11.7c-1.5,2.6-2.9,0.5-3.5,0.7c-0.3,0.1-2,1.8-2.4,2.3
  c0.3-0.6,0.9-2.2,0.4-2.2c-1.5,2.4-6.3-4.6-7.6-5c-0.2,1.4-27.3,47.7-31.4,50.4c2.1,0.2,2.1-2.2,4.4-2.1c1,0.9,2.1,1.2,3.4,0.9
  c1.9-0.1,5.9,2.4,6.5,4.4c1,3.3,1.1,6.8,0.5,10.1c-0.5,2.6-3.2,6.6-3.3,8.4c0.1-1,3.7,4.3,3.1,3.7c2.2,2.5,3.5,7,7,5.3
  c4.4-2.2,5.8,2.8,2.5,4.5c-2.3,1.1-4.4,5-4.8,8.1c2.1,3.3,4.7,3.7,4.8,7.5c0,1,2.5,5.5,3.4,5.7c2.5,0.7,3.9,0.5,4.7-0.3
  c0,0.5-0.2,1-0.4,1.4c0.9-0.6,1.7-0.9,2.4-0.8c-1,1.3-2.2,3.6-3.4,4.3c-3,1.8-4.4,6-6.5,8.8c0.8,2.8,3.5,3,5.8,3.8
  c-2.8-1-4,4-0.9,3c-5.4,1.1-0.5,5.4,0,7.2c0,0.1-8.5,10.9,0.2,19.4c3.2,3.2,1.9,9,0.7,12.7c9.1-1,71.5,34.8,73.1,36.3
  c1.2-1.4,5.3-5.9,5.6-7.1c0.8-4,0.2-8.1,1-12.3c1-4.8,3-8.5,1.8-13.4c-0.8-3.7-1.5-8.4-1-12.1c0.6-4.6-0.6-16.6,5.2-18
  c7.1-1.7,10.3-11.2,14-17.7 M404.9,138.8 M390.4,151 M374.1,101c0-0.2,0-0.4,0-0.6C374.1,100.6,374.1,100.8,374.1,101z`,
  SUDESTE: `M391.6,282.7c0.4-2.6-0.8-4.2-2.7-5.2c-1.3-0.7-2.2-2-2.6-3.4c-0.1-0.3-0.4-0.8-1.2-1.2
  c-3-2.3-3.8-3.3-3.1-7c0.8-4.4,1.3-1,3.4-2.8c-0.6,0.5,1.9-4.8,2.6-5.6c1.3-1.4,2.7-3.4,0.5-4.6c-3-1.7-6.1-3.1-9.3-3.7
  c-1.9-0.4-4.4,2.2-5.7,0.1c-1.2-1.9-1.6-3.7-3.4-5.3c-2.8-2.5-8,0.6-10.3-3c-2.6-0.6-5.2-4.4-8.1-3.9c-0.7,0.1-3.4,2.4-4.1,1.2
  c-5.7-1.2-0.4-5.2-5.4-5.5c-8.8-0.5-15.1,8.9-23.3,11.2c0.4-0.4,1.9-3.6,0.9-3.9c-0.2-0.1-6.1-1.9-5.7-2.1c-1.2,0.5,1.2,4.1-1,4.2
  c-1.8-0.9-3.9-1.1-3.8,1.6c0.8,0.2,1.9,7.8-0.1,8.5c-3.8,1.3-4.7,1.4-5.6,6c-0.7,3.4,5.8,4.1,1.2,8.2c-4.8,4.2,1.5,3.2,0.1,6.6
  c-0.4,1.1,0.4,3.2,0.1,3.9c-0.7,1.5-2.7,1.6-3.7,3c-3.9,5.5-14.2-3.4-19.8,3.9c-3.3-6.5-20.5,8.3-18.8,13.4c-0.5,2,0.1,3.3,2.2,2.2
  c0.1-0.1,0.2-0.1,0.3-0.2c-3,1.9-7.2,5-8.4,7.4c-2.2,4.2-4.8,9.1-6.1,13c-2,5.8-8.3,6.4-11.5,10.8c0.6,0.7,8.7-0.2,10.4,0.4
  c0.3-3.1,5.5,0.2,7.1,0.3c1.2,0,9.9,2.8,10.1,2.7c2.4,0.4,8.2-1.1,9.1,1.9c3.8-0.1,3.1,5.5,3.6,7.4c0.7,2.8,2.7,4.8,3.8,7.8
  c0.5,1.5-2.5,3.3,0.4,3.9c1.2,0.2,3.6-0.2,4.9-0.1c4.1,0.4,1.3,4.3,2.3,4.5c1.4,0.3,3.6-1.5,4-0.1c0.4,1.2,1.8,2.5,1.6,2.7
  c2.7-2.2,15.4-17.3,19.6-15.3c2.3,1,5-4.2,9.3-1.9c1.4,0.7,2.6-4.8,4.8-3.4c3.1-1.8,3-0.6,3-2.7c1.2,3.1,3.4-0.6,1.9-0.8
  c0.1-2.3,3.3-1.3,3.9-3c0.6,0.1,3.8,0.2,3.4,0.1c1.9-1.7,3.2-0.6,4.9,0.1c-1.4,0.1-2.7,0.4-4.1,0.8c-0.2,0.6,6.7-0.5,7.4-0.5
  c0.8,0,0.7-2.7,0.7-2.7c0.6-0.8,1.4-1.2,2.5-1.1c-1.3,5.5,5.1,2.8,9.3,3.2c5.1,0.5,2.3-2.9,3.4-4.9c2.3-4.4,11.3-3.1,11.1-8.8
  c-0.2-4.1,0-5.3-2.1-6.2c0-0.2,0-0.1,0.1-0.3c2,0.2,2.7,0,3.7-2.8c0.8-2.3,6.5-4.7,6.1-7.8c0-0.3,0-0.5,0.1-0.8
  c1.1-1.6,5.4-8.1,5.6-8.6C392.6,290.8,391.1,286.6,391.6,282.7z`,
};

const MapaRegioesBrasil = ({ data }) => {
  const [regiao, setRegiao] = useState({});

  const regioes = useMemo(
    () =>
      Object.keys(REGIOES_BRASILEIRAS).map((key) => ({
        regiao: key,
        d: REGIOES_BRASILEIRAS[key],
      })),
    []
  );

  const handleChange = useCallback(
    (currentRegion) => {
      const selectedRegion = data.find(
        ({ regiao: id }) => id === currentRegion
      );

      setRegiao({ ...selectedRegion, regiao: currentRegion });
    },
    [data]
  );

  return (
    <MapaPremiosContainer>
      <JsonData {...{ regiao }} disabledView />
      <Text
        text="Toque nas regiões do mapa para mais detalhes ;)"
        textType="caption"
        center
      />
      <RegionDetails
        className={regiao?.regiao ? regiao?.regiao.toLocaleLowerCase() : null}
        show={regiao?.regiao}
        header={<Text textType="headline" styleAs="7" text={regiao.nome} />}
        footer={
          <Text
            center
            textType="caption"
            text={`${regiao.qdtTitulos || 0} títulos sorteados`}
          />
        }
      >
        <Text as="small" textType="caption" text="R$ " />
        <Text as="span" textSize="lg">
          {formatCurrency(regiao?.valorPremio || 0).replace("R$ ", "")}
        </Text>
        <Text as="small" textType="caption" text=" em prêmios" />
      </RegionDetails>
      <MapaPremiosContent>
        <MapaImage
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 450 460"
          stroke="currentColor"
        >
          <g>
            {applyKey(regioes, ({ regiao: currentRegion, d }) => (
              <Regiao
                id={regiao?.regiao}
                d={d}
                title={regiao}
                active={currentRegion === regiao?.regiao}
                onMouseOver={() => handleChange(currentRegion)}
                onClick={() => handleChange(currentRegion)}
              />
            ))}
          </g>
        </MapaImage>
      </MapaPremiosContent>
    </MapaPremiosContainer>
  );
};

MapaRegioesBrasil.defaultProps = {
  data: [],
};

MapaRegioesBrasil.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      regiao: PropTypes.string.isRequired,
      nome: PropTypes.string.isRequired,
      valorPremio: PropTypes.number,
      qdtTitulos: PropTypes.number,
    })
  ),
};

export default MapaRegioesBrasil;
